module.exports = __webpack_public_path__ + "static/media/KENYA.d63c83a1.png";